<template>
  <div>
    <spinner-three-bounce :displayNone="!isLoading"/>

    <div v-show="!isLoading">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-8">
                  <h2 class="font-bold">
                    Détail de la commande #{{ commandId }}
                    <small>(crée le : {{ command.creationDate | formatDate }})</small>
                  </h2>
                  <component-status :status="command.status"></component-status>
                </div>
                <div class="col-sm-3 pull-right text-right">
                  <div>
                    <label class="control-label" for="commercial">Commercial assigné
                      <select name="commercial"
                              id="commercial"
                              class="form-control m-t-xs"
                              v-model="commercial.id">
                        <option v-for="manager in accountManager"
                                :key="manager.id"
                                :value="manager.id">{{ manager.firstname + ' ' + manager.lastname }}
                        </option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- fin Detail de la commande -->

      <component-alert v-if="lemonwayBankFootprintError"
                       type="danger"
                       :label="lemonwayBankFootprintErrorMessage"/>

      <!-- detail MODE DE CESSION  -->
      <div v-if="command.saleRdv || command.delivery"
           class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-12">
                  <span><i class="fa fa-calendar"></i> {{ saleRdvLabel }} </span>
                </div>
              </div>
              <component-alert v-if="willBeExpired"
                               type="danger"
                               label="Le contrôle technique ne sera plus valide au moment de la vente"/>
            </div>
          </div>
        </div>
      </div>
      <!-- fin mode de cession -->

      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5><i class="fa fa-file"></i>&nbsp;Options choisies par l'acheteur</h5>
            </div>
            <div class="ibox-content">
              <div class="table-responsive m-t">
                <table class="table invoice-table table-order">
                  <thead>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  :disabled="true"
                                  v-if="this.isFinalized()"
                          >
                            <option v-if="optionsOldWarranty.id" :value="optionsOldWarranty.id">{{ optionsOldWarranty.name }}
                            </option>
                          </select>

                          <select name="options"
                                  class="form-control border-none"
                                  @change="onChangeOptions('warranty')"
                                  :disabled="warrantyDisabled"
                                  v-model="options.warranty"
                                  v-else
                          >
                            <option v-if="optionsOldWarranty.id" :value="optionsOldWarranty.id">{{ optionsOldWarranty.name }}
                            </option>
                            <option v-for="option in warrantyOptions"
                                    :key="option.id"
                                    :value="option.id">{{ option.name }}
                            </option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div v-if="warrantyOptionDisabled && warrantyOptionReference()">
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  :disabled="warrantyDisabled"
                                  v-model="options.warrantyOption">
                            <option :value="null">Sans option</option>
                            <option v-if="warrantyOptionReference()"
                                    :value="warrantyOptionReference().reference" >{{ warrantyOptionReference().name }}
                            </option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td></td>
                    <td>{{ getWarrantyPrice }} €</td>
                    <td v-if="!this.isFinalized()">
                      <a v-if="warrantyDisabled"
                         @click.prevent.stop="confirm('warranty')">Changer de garantie</a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  @change="onChangeOptions('appointment')"
                                  :disabled="disposalTypeDisabled"
                                  v-model="options.disposalType">
                            <option :value="appointmentMode.DELIVERY">Livraison</option>
                            <option :value="appointmentMode.DISPOSAL">Rendez-vous de cession</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>{{ getDisposalPrice }} €</td>
                    <td v-if="!this.isFinalized()"><a v-if="disposalTypeDisabled"
                           @click.prevent.stop="confirm('disposal')">Modifier ce mode de cession</a></td>
                  </tr>
                  <tr v-show="options.disposalType === appointmentMode.DELIVERY">
                    <td>
                      <div>
                        <label>
                          <div class="input-group m-b">
                            <span class="input-group-addon"><i class="fa fa-map-marker"></i></span>
                            <gmap-autocomplete ref="gmapAddress"
                                               :componentRestrictions="{'country': ['fr']}"
                                               placeholder="Entrer une adresse postale"
                                               class="form-control"
                                               @change="resetAddress"
                                               @place_changed="onPlaceChanged"
                                               :disabled="!this.isFinalized() ? false : true"
                            />
                          </div>
                        </label>
                      </div>
                      <component-alert v-if="completeAddressNeeded"
                                       type="danger"
                                       label="Veuillez saisir une adresse complète pour continuer"/>
                    </td>
                    <td/>
                    <td/>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  @change="onChangeOptions('grise')"
                                  :disabled="carRegistrationDocumentDisabled"
                                  v-model="options.carRegistrationDocument">
                            <option :value="null">Sans Carte grise</option>
                            <option :value="carRegistrationDocumentOption.DOCUMENTWITH">Carte grise </option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div v-if="options.carRegistrationDocument">
                        <label class="control-label">
                          <input
                              name="zipCode"
                              type="text"
                              class="form-control"
                              placeholder="Saisir un code postal"
                              @input="onRegistrationDocumentChangeZipCodeOptions()"
                              :disabled="carRegistrationDocumentDisabled"
                              v-model="zipCode"
                          />
                        </label>
                      </div>
                    </td>
                    <td></td>
                    <td>{{ getRegistrationCertificatePrice }}  €</td>
                    <td v-if="!this.isFinalized()"><a v-if="carRegistrationDocumentDisabled"
                           @click.prevent.stop="confirm('grise')">Modifier l'option carte grise</a></td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  @change="onChangeOptions('immat')"
                                  :disabled="registrationDisabled"
                                  v-model="options.registration">
                            <option :value="null">Sans plaques d’immatriculation</option>
                            <option :value="registrationOption.REGISTRATIONWITH">Plaques d’immatriculation</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div v-if="options.registration">
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  :disabled="registrationDisabled"
                                  v-model="area">
                            <option :value="null">Choisissez votre région</option>
                            <option v-for="option in areaList"
                                    :key="option.id"
                                    :value="option.id">{{ option.name }}</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>
                      <div v-if="options.registration">
                        <label class="control-label">
                          <select name="options"
                                  class="form-control border-none"
                                  :disabled="registrationDisabled"
                                  v-model="department">
                            <option :value="null">Choisissez votre département</option>
                            <option v-for="option in filteredAndSorted()"
                                    :key="option.id"
                                    :value="option.id">{{ option.name }}</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td>{{ getRegistrationPrice }} €</td>
                    <td v-if="!this.isFinalized()"><a v-if="registrationDisabled"
                           @click.prevent.stop="confirm('immat')">Modifier l'option d'immatriculation</a></td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <label class="control-label" for="commercial">
                          <select name="options"
                                  class="form-control border-none"
                                  @change="onChangeOptions()"
                                  :disabled="paymentDisabled"
                                  v-model="options.payment">
                            <option :value="paymentMode.TRANSFER_PAYMENT_MODE">Paiement par virement bancaire</option>
                            <option :value="paymentMode.BANK_CHECK_PAYMENT_MODE">Paiement par chèque de banque</option>
                            <option :value="paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE">Crédit MOBILIZE</option>
                            <option :value="paymentMode.CREDIT_PAYMENT_MODE_COFIDIS">Crédit COFIDIS</option>
                            <option :value="paymentMode.CREDIT_PAYMENT_MODE_YOUNITED">Crédit YOUNITED</option>
                          </select>
                        </label>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td v-if="!this.isFinalized()"><a v-if="paymentDisabled"
                           @click.prevent.stop="confirm('payment')">Modifier ce moyen de paiement</a></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <a v-if="isOld" :href="getCreditUrl"
                         class="btn btn-primary pull-right"
                         type="button"
                         disabled
                         onclick="return false"
                         v-tooltip="{
                          content: 'Le véhicule à plus de 12 ans',
                          placement: 'bottom-center'
                         }"
                      >
                        <i class="fa fa-credit-card-alt"></i> Demande de crédit
                      </a>
                      <a v-else :href="getCreditUrl"
                         target="_blank"
                         class="btn btn-primary pull-right"
                         type="button"
                      >
                        <i class="fa fa-credit-card-alt"></i> Demande de crédit
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div><!-- /table-responsive -->
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="isVenteDirect">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5><i class="fa fa-file-text"></i> Coût certificat d'immatriculation</h5>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-md-6">
                  <div class="widget lazur-bg p-xl">
                    <h2><i class="fa fa-car"></i> Informations du véhicule</h2>
                    <div class="row m-t-md">
                      <div class="col-md-5">
                        Genre du VO :
                      </div>
                      <div class="col-md-7">
                      </div>
                      <span class="font-bold text-uppercase">{{ this.vehicle.typeOfVehicle }}</span>
                    </div>
                    <div class="row">
                      <div class="col-md-5">
                        Puissance administrative :
                      </div>
                      <div class="col-md-7">
                      </div>
                      <span class="font-bold text-uppercase">{{ this.vehicle.taxHorsePower }}</span>
                    </div>
                    <div class="row">
                      <div class="col-md-5">
                        Energie :
                      </div>
                      <div class="col-md-7">
                      </div>
                      <span class="font-bold text-uppercase">{{ this.vehicle.fuel }}</span>
                    </div>
                    <div class="row">
                      <div class="col-md-5">
                        Département d'immatriculation :
                      </div>
                      <div class="col-md-7">
                      </div>
                      <span class="font-bold text-uppercase">{{ getZipCode }}</span>
                    </div>
                  </div>
                  <div class="alert alert-info">
                    <a href="https://www.service-public.fr/simulateur/calcul/cout-certificat-immatriculation"
                       target="_blank">
                      <i class="fa fa-info-circle"></i><span class="font-bold">Aide:</span> lien pour calculer les coûts
                      d'un certificat d'immatriculation en ligne manuellement
                    </a>
                  </div>
                </div>
                <div class="col-md-6">
                  <form action="">
                    <div class="row">
                      <label class="col-lg-4">Code postal :</label>
                      <div class="col-lg-4">
                        <div class="input-group m-b">
                          <input name="codePostalCarInfoTax"
                                 min="0"
                                 class="form-control form-control-sm m-b"
                                 placeholder="Code postal"
                                 v-model="zipCode"
                          />
                          <span class="input-group-addon">
                            <i class="fa fa-map-marker"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-lg-4">Coût de la carte grise:</label>
                      <div class="col-lg-4">
                        <div class="input-group m-b">
                          <input name="amountCarInfotax"
                                 min="0"
                                 class="form-control form-control-sm m-b"
                                 placeholder="Coût de la carte grise"
                                 v-model="infoCGTax"
                          />
                          <span class="input-group-addon">
                            <i class="fa fa-euro"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4"></div>
                      <div class="col-lg-4">
                        <button
                            class="btn btn-primary text-center"
                            :class="{}"
                            title="Enregistrer le coût de la carte grise"
                            type="button"
                            @click="addTaxAmount"
                        > Enregistrer le montant
                        </button>
                      </div>
                    </div>
                  </form>
                  <hr>
                  <div>
                    <p class="font-bold">Montant enregistré : <span
                        :class="{ 'label-primary': infoCGTax, 'label-warning' : !infoCGTax }"
                        class="label label-documents" style="font-size: 16px;">{{ getTaxAmountAsSting }}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Accordion title="À payer par l'acheteur" titleIcon="fa fa-usd">
        <template slot="content">
          <div class="table-responsive m-t">
            <table class="table">
              <thead>
              <tr>
                <th class="w-50-percent">Détail<br></th>
                <th class="text-right">Au vendeur<br>
                  {{ getBuyerToSellerTotalPrice | formatDecimalPrice }} € TTC
                </th>
                <th class="text-right">À Carizy<br>
                  {{ getBuyerToCarizyTotalPrice | formatDecimalPrice }} € TTC
                </th>
                <th class="text-navy text-centerquery text-right">Total<br>
                  {{ getBuyerTotalPrice | formatDecimalPrice }} € TTC
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <div>Véhicule</div>
                </td>
                <td class="text-right">{{ getPriceOfVehicle | formatDecimalPrice }} €</td>
                <td class="text-right"></td>
                <td class="text-right" rowspan="2" style="vertical-align: middle;">
                  {{ getSellerPrice | formatDecimalPrice }} €
                </td>
              </tr>
              <tr>
                <td>
                  <div>Commission</div>
                </td>
                <td></td>
                <td class="text-right"
                    ref="buyer-to-carizy">{{ getSaleCommission | formatDecimalPrice }} €
                </td>
              </tr>
              <tr>
                <td>
                  <div>Frais de formalité</div>
                </td>
                <td></td>
                <td class="text-right"
                    ref="buyer-to-carizy">{{ getFormalityPrice | formatDecimalPrice }} €
                </td>
                <td class="text-right">{{ getFormalityPrice | formatDecimalPrice }} €</td>
              </tr>
              <tr v-if="warrantyOptions.length && options.warranty">
                <td>
                  <div>{{ getWarrantyLabel }}</div>
                </td>
                <td></td>
                <td class="text-right">{{ getWarrantyPrice | formatDecimalPrice }} €</td>
                <td class="text-right">{{ getWarrantyPrice | formatDecimalPrice }} €</td>
              </tr>
              <tr v-if="options.disposalType">
                <td>
                  <div>{{ getDisposalLabel }}</div>
                </td>
                <td></td>
                <td class="text-right">{{ getDisposalPrice | formatDecimalPrice }} €</td>
                <td class="text-right">{{ getDisposalPrice | formatDecimalPrice }} €</td>
              </tr>
              <tr>
                <td>
                  <div>Carte grise</div>
                </td>
                <td></td>
                <td class="text-right"
                    ref="buyer-to-carizy">{{ getRegistrationCertificatePrice }} €
                </td>

                <td class="text-right">{{ getRegistrationCertificatePrice }} €</td>
              </tr>
              <tr v-if="getCarRegistrationDocumentEcoTaxPrice !== 0">
                <td>
                  <div>Dont écotaxe</div>
                </td>
                <td></td>
                <td class="text-right"
                    ref="buyer-to-carizy">{{ getCarRegistrationDocumentEcoTaxPrice }} €
                </td>

                <td class="text-right">{{ getCarRegistrationDocumentEcoTaxPrice }} €</td>
              </tr>
              <tr>
                <td>
                  <div>Plaques d’immatriculation</div>
                </td>
                <td></td>
                <td class="text-right"
                    ref="buyer-to-carizy">{{ getRegistrationPrice }} €
                </td>
                <td class="text-right">{{ getRegistrationPrice }} €</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>

        <template slot="content">
          <div class="table-responsive m-t">
            <table class="table">
              <thead>
              <tr>
                <th v-if="credit_payment_mode.isCredit && credit_payment_mode.email" class="w-50-percent">Financement
                  :<br><br></th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.deposit">
                <td>
                  <div>Apport</div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center" style="padding-top: 1%; padding-left:6%;"> {{
                    this.credit_payment_mode.deposit
                  }} €
                </td>
              </tr>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.amountBorrowed">
                <td>
                  <div>Montant emprunté</div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center" style="padding-top: 1%; padding-left:6%;">
                  {{ this.credit_payment_mode.amountBorrowed }} €
                </td>
              </tr>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.durationValues">
                <td>
                  <div>Durée</div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center" style="padding-top: 1%; padding-left:6%;">
                  {{ this.credit_payment_mode.durationValues }} mois
                </td>
              </tr>
              <tr v-if="credit_payment_mode.isCredit &&  this.credit_payment_mode.amountTotal">
                <td>
                  <div>Montant total dû (hors assurances)</div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center" style="padding-top: 1%; padding-left:6%;">
                  {{ this.credit_payment_mode.amountTotal }} €
                </td>
              </tr>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.financingCost">
                <td>
                  <div>Coût du financement (hors assurances)</div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center" style="padding-top: 1%; padding-left:6%;">
                  {{ this.credit_payment_mode.financingCost }} €
                </td>
              <tr></tr>
              <td v-if="credit_payment_mode.isCredit && this.credit_payment_mode.filingFees" style="padding-bottom: 1%">
                <div><i>&emsp; &emsp;Dont frais de dossier </i></div>
              </td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td v-if="credit_payment_mode.isCredit && this.credit_payment_mode.filingFees" class="text-center"
                  style="padding-bottom: 1%;padding-left:6%;"><i> {{ this.credit_payment_mode.filingFees }} €</i></td>
              <br>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.taeg">
                <td>
                  <div>TAEG fixe</div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center" style="padding-top: 1%; padding-left:6%;"> {{ this.credit_payment_mode.taeg }}
                  %
                </td>
              </tr>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.lendingRate">
                <td>
                  <div>Taux débiteur fixe</div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center" style="padding-top: 1%; padding-left:6%;">
                  {{ this.credit_payment_mode.lendingRate }} %
                </td>
              </tr>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.monthlyPaymentWithoutInsurance">
                <td>
                  <div><b>Mensualités hors assurances </b></div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td v-if="credit_payment_mode.isCredit && this.credit_payment_mode.monthlyPaymentWithoutInsurance"
                    class="text-center" style="padding-top: 1%; padding-left:6%;"><b>
                  {{ this.credit_payment_mode.monthlyPaymentWithoutInsurance }} €</b></td>
              </tr>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.insurances.name">
                <td>
                  <div>{{ this.credit_payment_mode.insurances.name }}</div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center" style="padding-top: 1%; padding-left:6%;">
                  {{ this.credit_payment_mode.insurances.rent }} € / mois
                </td>
              </tr>
              <td v-if="credit_payment_mode.isCredit && this.credit_payment_mode.insurances.taea">
                <div>&emsp; &emsp; <i>TAEA </i></div>
              </td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td v-if="credit_payment_mode.isCredit && this.credit_payment_mode.insurances.taea" class="text-center"
                  style="padding-left:6%;"> {{ this.credit_payment_mode.insurances.taea }} %
              </td>
              <tr></tr>
              <td v-if="credit_payment_mode.isCredit && this.credit_payment_mode.insurances.totalCost"
                  style="padding-bottom: 1%">
                <div>&emsp; &emsp; <i>Coût total des assurances emprunteur </i></div>
              </td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td v-if="credit_payment_mode.isCredit && this.credit_payment_mode.insurances.totalCost"
                  class="text-center" style="padding-bottom: 1%;padding-left:6%;"><i>
                {{ this.credit_payment_mode.insurances.totalCost }} €</i></td>
              <tr v-if="credit_payment_mode.isCredit && this.credit_payment_mode.monthlyPayment">
                <td>
                  <div><b>Mensualités totales </b></div>
                </td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td v-if="credit_payment_mode.isCredit &&  this.credit_payment_mode.monthlyPayment" class="text-center"
                    style="padding-top: 1%; padding-left:6%;"><b> {{ this.credit_payment_mode.monthlyPayment }} €</b>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
      </Accordion>

      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-content">
              <div class="table-responsive m-t">
                <table class="table invoice-table table-order">
                  <thead>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <div>
                        <p> Total dû : </p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ getBuyerTotalPrice | formatDecimalPrice }} €
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p> Sommes perçues (argent séquestré) : </p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ getReceivedAmount | formatDecimalPrice }} €
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p> Sommes restant dû : </p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ getRemainingAmount | formatDecimalPrice }} €
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p> Sommes à régler pour valider les options :</p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ getChangeOptionsAmount | formatDecimalPrice }} €
                    </td>
                  </tr>
                  <tr v-if="credit_payment_mode.isCredit &&  credit_payment_mode.loanPrice">
                    <td>
                      <div>
                        <p>Montant emprunté : </p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ credit_payment_mode.loanPrice | formatDecimalPrice }} €
                    </td>
                  </tr>
                  <tr v-if="credit_payment_mode.isCredit && credit_payment_mode.remainingAmount">
                    <td>
                      <div>
                        <p>Somme restant dû à régler par virement bancaire : </p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ credit_payment_mode.remainingAmount | formatDecimalPrice }} €
                    </td>
                  </tr>
                  <tr v-if="getOverAmount <= 0">
                    <td>
                      <div>
                        <p> Trop perçues : </p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ getOverAmount | formatDecimalPrice }} €
                    </td>
                  </tr>
                  <tr v-if="getOverAmount > 0">
                    <td>
                      <div>
                        <p style="color: red"> Trop perçues : </p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td style="color: red">
                      {{ getOverAmount | formatDecimalPrice }} €
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="showSatisfactionSection">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Avis client</h5>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-md-3">Le client est-il satisfait ?</div>
                <div class="col-md-4">
                  <select name="options"
                          class="form-control"
                          v-model="satisfaction.satisfaction">
                    <option disabled value="">Veuillez choisir</option>
                    <option v-for="option in satisfactionOptions"
                            :key="option.id"
                            :value="option.name">{{ option.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" style="margin-top: 20px;">
                <div class="col-md-3">Détails de l'avis du client :</div>
                <div class="col-md-4">
                  <textarea class="form-control" v-model="satisfaction.comment" placeholder="" rows="2"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="hasDatePassed" class="row ibox">
        <div class="col-lg-12 text-center">
          <button class="btn btn-danger btn-cancel" type="button" @click="nonSold()"><i class="fa fa-times"></i>
            Véhicule non vendu
          </button>
          <button class="btn btn-primary" type="button" @click="sold()"><i class="fa fa-check"></i> Véhicule vendu
          </button>
          <template v-if="displayReplanButton">
            <button class="btn btn-success btn-replanifier" type="button" @click="replan()"><i class="fa fa-check"></i>
              Rdv à replanifier
            </button>
          </template>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-4">
          <button class="btn btn-danger"
                  type="button"
                  @click="deleteOrder()">
            <i class="fa fa-times"></i> Annuler la commande
          </button>
        </div>
        <div class="col-md-4">
          <button class="btn btn-success text-center"
                  type="button"
                  :disabled="disableSubmit"
                  @click="modifyOrder">
            <i class="fa fa-check"></i> {{ saveButtonLabel }}
          </button>
        </div>
        <div class="col-md-4">
          <button class="btn btn-success text-center"
                  type="button"
                  @click="showCreditWalletModal()">
            <i class="fa fa-dollar"></i> Créditer le Wallet
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import CommercialList from '../../api/query/CommercialList.gql'
import {formatDateTime} from '../../helpers/filters/filter'
import {formatAddress, addressToString} from '../../helpers/utils'
import { appointmentMode, carRegistrationDocument, paymentMode, registration } from '@/helpers/utils/constants'
import Alert from '../../components/Alert.vue'
import Status from "@/components/details/Status.vue"
import store from '@/config/store'
import localStorage from '@/helpers/mixins/localStorage'
import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'
import Accordion from '@/components/accordion/accordion'
import {isAddressIncompleteMixin} from '@/mixins/isAddressIncompleteMixin'
import moment from 'moment'

const DELIVERY = appointmentMode.DELIVERY
const DISPOSAL = appointmentMode.DISPOSAL

const DOCUMENTWITH = carRegistrationDocument.with
const DOCUMENTWITHOUT = carRegistrationDocument.without
const REGISTRATIONWITH = registration.with
const REGISTRATIONWITHOUT = registration.without

const BANK_CHECK_PAYMENT_MODE = paymentMode.BANK_CHECK_PAYMENT_MODE
const TRANSFER_PAYMENT_MODE = paymentMode.TRANSFER_PAYMENT_MODE
const CREDIT_PAYMENT_MODE_MOBILIZE = paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE
const CREDIT_PAYMENT_MODE_COFIDIS = paymentMode.CREDIT_PAYMENT_MODE_COFIDIS
const CREDIT_PAYMENT_MODE_YOUNITED = paymentMode.CREDIT_PAYMENT_MODE_YOUNITED

export default {
  name: "Recapitulatif",

  props: {
    command: {
      type: Object,
      required: true
    }
  },

  components: {
    'component-alert': Alert,
    'component-status': Status,
    SpinnerThreeBounce,
    Accordion,
  },

  mixins: [isAddressIncompleteMixin],

  data: () => ({
    appointmentMode: {
      DELIVERY: DELIVERY,
      DISPOSAL: DISPOSAL
    },
    carRegistrationDocumentOption: {
      DOCUMENTWITH: DOCUMENTWITH,
      DOCUMENTWITHOUT: DOCUMENTWITHOUT
    },
    registrationOption: {
      REGISTRATIONWITH: REGISTRATIONWITH,
      REGISTRATIONWITHOUT: REGISTRATIONWITHOUT
    },
    paymentMode: {
      BANK_CHECK_PAYMENT_MODE: BANK_CHECK_PAYMENT_MODE,
      TRANSFER_PAYMENT_MODE: TRANSFER_PAYMENT_MODE,
      CREDIT_PAYMENT_MODE_MOBILIZE: CREDIT_PAYMENT_MODE_MOBILIZE,
      CREDIT_PAYMENT_MODE_COFIDIS: CREDIT_PAYMENT_MODE_COFIDIS,
      CREDIT_PAYMENT_MODE_YOUNITED: CREDIT_PAYMENT_MODE_YOUNITED
    },
    areaList: [
      {
        name: "Île-de-France",
        id: "ile-de-france",
      },
      {
        name: "Centre -Val de Loire",
        id: "centre-val-de-loire",
      },
      {
        name: "Bourgogne-Franche-Comté",
        id: "bourgogne-franche-comte",
      },
      {
        name: "Normandie",
        id: "normandie",
      },
      {
        name: "Hauts-de-France",
        id: "hauts-de-france",
      },
      {
        name: "Grand Est",
        id: "grand-est",
      },
      {
        name: "Pays de la Loire",
        id: "pays-de-la-loire",
      },
      {
        name: "Bretagne",
        id: "bretagne",
      },
      {
        name: "Nouvelle Aquitaine",
        id: "nouvelle-aquitaine",
      },
      {
        name: "Occitanie",
        id: "occitanie",
      },
      {
        name: "Auvergne-Rhône-Alpes",
        id: "auvergne-rhone-alpes",
      },
      {
        name: "Provence-Alpes-Côte d'Azur",
        id: "provence-alpes-cote-d-azur",
      },
      {
        name: "Corse",
        id: "corse",
      },
      {
        name: "Guadeloupe",
        id: "guadeloupe",
      },
      {
        name: "Martinique",
        id: "martinique",
      },
      {
        name: "Guyane",
        id: "guyane",
      },
      {
        name: "La Réunion",
        id: "la-reunion",
      },
      {
        name: "Mayotte",
        id: "mayotte",
      },
    ],
    departmentList: [
      {
        name: "94",
        area: 'ile-de-france',
        id: 94,
      },
      {
        name: "75",
        area: 'ile-de-france',
        id: 75
      },
      {
        name: "77",
        area: 'ile-de-france',
        id: 77
      },
      {
        name: "78",
        area: 'ile-de-france',
        id: 78
      },
      {
        name: "91",
        area: 'ile-de-france',
        id: 91
      },
      {
        name: "92",
        area: 'ile-de-france',
        id: 92
      },
      {
        name: "93",
        area: 'ile-de-france',
        id: 93
      },
      {
        name: "95",
        area: 'ile-de-france',
        id: 95
      },
      {
        name: "18",
        area: 'centre-Val-de-loire',
        id: 18
      },
      {
        name: "28",
        area: 'centre-Val-de-loire',
        id: 28
      },
      {
        name: "36",
        area: 'centre-Val-de-loire',
        id: 36
      },
      {
        name: "37",
        area: 'centre-Val-de-loire',
        id: 37
      },
      {
        name: "41",
        area: 'centre-Val-de-loire',
        id: 41
      },
      {
        name: "45",
        area: 'centre-Val-de-loire',
        id: 45
      },
      {
        name: "21",
        area: 'bourgogne-franche-comte',
        id: 21
      },
      {
        name: "25",
        area: 'bourgogne-franche-comte',
        id: 25
      },
      {
        name: "39",
        area: 'bourgogne-franche-comte',
        id: 39
      },
      {
        name: "58",
        area: 'bourgogne-franche-comte',
        id: 58
      },
      {
        name: "70",
        area: 'bourgogne-franche-comte',
        id: 70
      },
      {
        name: "71",
        area: 'bourgogne-franche-comte',
        id: 71
      },
      {
        name: "89",
        area: 'bourgogne-franche-comte',
        id: 89
      },
      {
        name: "90",
        area: 'bourgogne-franche-comte',
        id: 90
      },
      {
        name: "14",
        area: 'normandie',
        id: 14
      },
      {
        name: "27",
        area: 'normandie',
        id: 27
      },
      {
        name: "50",
        area: 'normandie',
        id: 50
      },
      {
        name: "61",
        area: 'normandie',
        id: 61
      },
      {
        name: "76",
        area: 'normandie',
        id: 76
      },
      {
        name: "02",
        area: 'hauts-de-france',
        id: '02'
      },
      {
        name: "59",
        area: 'hauts-de-france',
        id: 59
      },
      {
        name: "60",
        area: 'hauts-de-france',
        id: 60
      },
      {
        name: "62",
        area: 'hauts-de-france',
        id: 62
      },
      {
        name: "80",
        area: 'hauts-de-france',
        id: 80
      },
      {
        name: "08",
        area: 'grand-est',
        id: '08',
      },
      {
        name: "10",
        area: 'grand-est',
        id: 10
      },
      {
        name: "51",
        area: 'grand-est',
        id: 51
      },
      {
        name: "52",
        area: 'grand-est',
        id: 52
      },
      {
        name: "54",
        area: 'grand-est',
        id: 54
      },
      {
        name: "55",
        area: 'grand-est',
        id: 55
      },
      {
        name: "57",
        area: 'grand-est',
        id: 57
      },
      {
        name: "67",
        area: 'grand-est',
        id: 67
      },
      {
        name: "68",
        area: 'grand-est',
        id: 68
      },
      {
        name: "88",
        area: 'grand-est',
        id: 88
      },
      {
        name: "44",
        area: 'pays-de-la-loire',
        id: 44
      },
      {
        name: "49",
        area: 'pays-de-la-loire',
        id: 49
      },
      {
        name: "53",
        area: 'pays-de-la-loire',
        id: 53
      },
      {
        name: "72",
        area: 'pays-de-la-loire',
        id: 72
      },
      {
        name: "85",
        area: 'pays-de-la-loire',
        id: 85
      },
      {
        name: "22",
        area: 'bretagne',
        id: 22
      },
      {
        name: "29",
        area: 'bretagne',
        id: 29
      },
      {
        name: "35",
        area: 'bretagne',
        id: 35
      },
      {
        name: "56",
        area: 'bretagne',
        id: 56
      },
      {
        name: "16",
        area: 'nouvelle-aquitaine',
        id: 16
      },
      {
        name: "17",
        area: 'nouvelle-aquitaine',
        id: 17
      },
      {
        name: "19",
        area: 'nouvelle-aquitaine',
        id: 19
      },
      {
        name: "23",
        area: 'nouvelle-aquitaine',
        id: 23
      },
      {
        name: "24",
        area: 'nouvelle-aquitaine',
        id: 24
      },
      {
        name: "33",
        area: 'nouvelle-aquitaine',
        id: 33
      },
      {
        name: "40",
        area: 'nouvelle-aquitaine',
        id: 40
      },
      {
        name: "47",
        area: 'nouvelle-aquitaine',
        id: 47
      },
      {
        name: "64",
        area: 'nouvelle-aquitaine',
        id: 64
      },
      {
        name: "79",
        area: 'nouvelle-aquitaine',
        id: 79
      },
      {
        name: "86",
        area: 'nouvelle-aquitaine',
        id: 86
      },
      {
        name: "87",
        area: 'nouvelle-aquitaine',
        id: 87
      },
      {
        name: "09",
        area: 'occitanie',
        id: '09'
      },
      {
        name: "11",
        area: 'occitanie',
        id: 11
      },
      {
        name: "12",
        area: 'occitanie',
        id: 12
      },
      {
        name: "30",
        area: 'occitanie',
        id: 30
      },
      {
        name: "31",
        area: 'occitanie',
        id: 31
      },
      {
        name: "32",
        area: 'occitanie',
        id: 32
      },
      {
        name: "34",
        area: 'occitanie',
        id: 34
      },
      {
        name: "46",
        area: 'occitanie',
        id: 46
      },
      {
        name: "48",
        area: 'occitanie',
        id: 48
      },
      {
        name: "65",
        area: 'occitanie',
        id: 65
      },
      {
        name: "66",
        area: 'occitanie',
        id: 66
      },
      {
        name: "81",
        area: 'occitanie',
        id: 81
      },
      {
        name: "82",
        area: 'occitanie',
        id: 82
      },
      {
        name: "01",
        area: 'auvergne-rhone-alpes',
        id: '01'
      },
      {
        name: "03",
        area: 'auvergne-rhone-alpes',
        id: '03'
      },
      {
        name: "07",
        area: 'auvergne-rhone-alpes',
        id: "07"
      },
      {
        name: "15",
        area: 'auvergne-rhone-alpes',
        id: 15
      },
      {
        name: "26",
        area: 'auvergne-rhone-alpes',
        id: 26
      },
      {
        name: "38",
        area: 'auvergne-rhone-alpes',
        id: 38
      },
      {
        name: "42",
        area: 'auvergne-rhone-alpes',
        id: 42
      },
      {
        name: "43",
        area: 'auvergne-rhone-alpes',
        id: 43
      },
      {
        name: "63",
        area: 'auvergne-rhone-alpes',
        id: 63
      },
      {
        name: "69",
        area: 'auvergne-rhone-alpes',
        id: 69
      },
      {
        name: "73",
        area: 'auvergne-rhone-alpes',
        id: 73
      },
      {
        name: "74",
        area: 'auvergne-rhone-alpes',
        id: 74
      },
      {
        name: "04",
        area: 'provence-alpes-cote-d-azur',
        id: '04'
      },
      {
        name: "05",
        area: 'provence-alpes-cote-d-azur',
        id: '05'
      },
      {
        name: "06",
        area: 'provence-alpes-cote-d-azur',
        id: "06"
      },
      {
        name: "13",
        area: 'provence-alpes-cote-d-azur',
        id: 13
      },
      {
        name: "83",
        area: 'provence-alpes-cote-d-azur',
        id: 83
      },
      {
        name: "84",
        area: 'provence-alpes-cote-d-azur',
        id: 84
      },
      {
        name: "2A",
        area: 'corse',
        id: '2A'
      },
      {
        name: "2B",
        area: 'corse',
        id: '2B'
      },
      {
        name: "971",
        area: 'guadeloupe',
        id: 971
      },
      {
        name: "972",
        area: 'martinique',
        id: 972,
      },
      {
        name: "973",
        area: 'guyane',
        id: 973,
      },
      {
        name: "974",
        area: 'la-reunion',
        id: 974
      },
      {
        name: "976",
        area: 'mayotte',
        id: 976,
      }
    ],
    area: null,
    department: null,
    accountManager: [],
    warrantyOptions: [],
    fromBO: true,
    satisfactionOptions: [
      {id: 1, name: "oui"},
      {id: 2, name: "non"}
    ],
    satisfaction: {
      satisfaction: "",
      comment: ""
    },
    warrantyContract: {
      opteven: {
        id: null
      },
      yousign: {
        id: null
      }
    },
    options: {
      warranty: null,
      payment: null,
      warrantyOption: null,
      disposalType: null,
      carRegistrationDocument: null,
      registration: null,
    },
    optionsOldWarranty: {
      id: null,
      name: null
    },
    warrantyDisabled: true,
    warrantyOptionDisabled: false,
    paymentDisabled: true,
    disposalTypeDisabled: true,
    registrationDisabled:  true,
    carRegistrationDocumentDisabled:  true,
    displayReplanButton: false,
    codePromo: {
      showInput: false,
      input: '',
      details: null
    },
    checkPromoCode: null,
    delivery: {
      isDelivery: false,
      address: {
        address: "",
        city: "",
        zipCode: ""
      },
      coordinate: {
        start: {
          latitude: null,
          longitude: null,
        },
        end: {
          latitude: null,
          longitude: null,
        }
      }
    },
    purchasePaymentResponseToken: "",
    lemonwayBankFootprintError: false,
    lemonwayBankFootprintErrorMessage: "",
    commercial: {
      firstname: "",
      id: "",
      lastname: ""
    },
    purchasePaymentSuccessisLoading: false,
    customerSatisfactionQueryisLoading: false,
    getDeliveryInfosQueryisLoading: false,
    credit: {
      amount: ""
    },
    AmountOption: {
      warranty: 0,
      appointment: 0,
      carRegistrationDocument: 0,
      registration: 0,
    },
    appointmentDate: null,
    credit_payment_mode: {
      isCredit: false,
      email: "",
      deposit: "",
      amountBorrowed: "",
      durationValues: "",
      amountTotal: "",
      financingCost: "",
      filingFees: "",
      taeg: "",
      lendingRate: "",
      monthlyPaymentWithoutInsurance: "",
      monthlyPayment: "",
      insurances: {
        name: "",
        rent: "",
        taea: "",
        totalCost: "",
      }
    },
    isNewDeliveryAddress: false,
    infoCGTax: null,
    zipCode: '',
    ecotaxe: 'Ecotaxe',
    orderInfo: {
      warranty: {
        isPremiumMapFre: "",
        label: "",
        price: "",
        surtaxedWarrantyPrice: ""
      },
      delivery: {
        address: "",
        zipCode: "",
        city: "",
      },
      deliveryPrice: "",
      paymentMode: "",
      feesPrice: "",
      receivedAmount: "",
      totalAmount: "",
      remainingAmount: "",
      saleCommission: "",
      overAmount: "",
      buyerPrice: "",
      sellerPrice: "",
      changeOptionsAmount: "",
      totalOperationAmount: "",
      registrationPrice: "",
      registrationCertificatePrice: "",
      carRegistrationDocumentEcoTaxPrice: ""
    },
  }),

  computed: {
    isOld() {
      let date12YearsAgo = moment().subtract(12, 'years')
      return moment(date12YearsAgo).isAfter(moment(this.vehicle.releaseDate, "DD/MM/YYYY"))
    },
    taxAmoutMutation() {
      return gql`
        mutation {
            setTaxAmount (
                orderId: "${this.commandId}",
                amount: ${this.infoCGTax},
                zipcode: "${this.zipCode}",
            ){ status }
        }`
    },
    warrantyContractInfoMutation() {
      return gql`
        mutation {
            setWarrantyContractInfo (
                orderId: "${this.commandId}",
                optevenContractId: "${this.warrantyContract.opteven.id}",
                youSignContractId: "${this.warrantyContract.yousign.id}",
            ){ status result message }
        }`
    },
    zipCode() {
      return this.delivery.address.zipCode;
    },

    isLoading() {
      if (
          this.purchasePaymentSuccessisLoading ||
          this.customerSatisfactionQueryisLoading ||
          this.getDeliveryInfosQueryisLoading
      ) {
        return true
      } else {
        return false
      }
    },
    completeAddressNeeded() {
      return this.options.disposalType === appointmentMode.DELIVERY && this.isAddressIncomplete(this.delivery.address)
    },

    disableSubmit() {
      return this.completeAddressNeeded || this.commercial.id.length === 0
    },

    showSatisfactionSection() {
      if (this.command.status.id == Status.constants.SOLD || this.command.status.id == Status.constants.TO_FINALIZE) {
        return true
      } else {
        return false
      }
    },
    commandId() {
      return this.$route.params.id
    },

    adSupplier() {
      return this.command.ad.supplier
    },

    vehicle() {
      return this.command.vehicule[0]
    },

    buyer() {
      return this.command.buyer[0]
    },

    getFormalityPrice() {
      return parseFloat(this.orderInfo.feesPrice ? this.orderInfo.feesPrice : 0)
    },

    getWarrantyPrice() {
      return parseFloat(this.orderInfo.warranty.price ? this.orderInfo.warranty.price : 0)
    },

    getBuyerPrice() {
      return parseFloat(this.orderInfo.buyerPrice ? this.orderInfo.buyerPrice : 0)
    },

    getSellerPrice() {
      return parseFloat(this.orderInfo.buyerPrice ? this.orderInfo.buyerPrice : 0)
    },

    getPriceOfVehicle() {
      return this.getBuyerPrice - this.getSaleCommission
    },

    getSaleCommission() {
      return parseFloat(this.orderInfo.saleCommission ? this.orderInfo.saleCommission : 0)
    },
    getReceivedAmount() {
      return parseFloat(this.orderInfo.receivedAmount ? this.orderInfo.receivedAmount : 0)
    },

    getRealm() {
      return this.command.realm
    },


    getRemainingAmount() {
      return parseFloat(this.orderInfo.remainingAmount)
    },

    getOverAmount() {
      if (((parseFloat(this.getBuyerToCarizyTotalPrice) + parseFloat(this.orderInfo.sellerPrice)) - parseFloat(this.orderInfo.receivedAmount)) < 0) {
        return -1 * parseFloat(Math.min(0, (parseFloat(this.getBuyerToCarizyTotalPrice) + parseFloat(this.orderInfo.sellerPrice)) - parseFloat(this.orderInfo.receivedAmount)).toString())
      }
      return 0
    },

    getChangeOptionsAmount() {
      return parseFloat(this.orderInfo.changeOptionsAmount)
    },

    isVenteDirect() {
      return this.adSupplier === 'renault'
    },

    getDisposalLabel() {
      switch (this.options.disposalType) {
        case appointmentMode.DELIVERY:
          return 'Livraison'
        case appointmentMode.DISPOSAL:
          return 'Rendez-vous de cession'
        default:
          return ''
      }
    },

    getWarrantyLabel() {
      return this.orderInfo.warranty.label
    },

    getDisposalPrice() {
      return parseFloat(this.orderInfo.deliveryPrice ? this.orderInfo.deliveryPrice : 0)
    },

    getRegistrationCertificatePrice() {
      return parseFloat(this.orderInfo.registrationCertificatePrice ? this.orderInfo.registrationCertificatePrice : 0)
    },
    getCarRegistrationDocumentEcoTaxPrice() {
      return parseFloat(this.orderInfo.carRegistrationDocumentEcoTaxPrice ? this.orderInfo.carRegistrationDocumentEcoTaxPrice : 0)
    },

    getRegistrationPrice () {
      return parseFloat(this.orderInfo.registrationPrice ? this.orderInfo.registrationPrice : 0)
    },

    getZipCode() {
      return this.zipCode
    },

    getBuyerToCarizyTotalPrice() {
      return parseFloat(this.getDisposalPrice) + parseFloat(this.getFormalityPrice) + parseFloat(this.getSaleCommission) + parseFloat(this.getRegistrationCertificatePrice) + parseFloat(this.getRegistrationPrice);
    },

    getBuyerToSellerTotalPrice() {
      return parseFloat(this.orderInfo.buyerPrice) - parseFloat(this.orderInfo.saleCommission)
    },

    getBuyerTotalPrice() {
      return parseFloat(this.orderInfo.totalAmount)
    },

    saleRdvLabel() {
      if (!this.command.saleRdv && !this.command.delivery) {
        return null
      }

      let label = this.command.delivery ? 'Livraison' : 'Rendez-vous de cession'

      if (this.appointmentDate === null || this.appointmentDate === "") {
        label += ' non planifié'

        if (this.command.delivery) {
          label += 'e'
        }
      } else {
        label += ' le ' + formatDateTime(this.appointmentDate)

        if (!this.command.delivery && this.command.saleRdvExpert && this.command.saleRdvExpert.name) {
          label += ` avec ${this.command.saleRdvExpert.name} (${this.command.saleRdvExpert.phonenumber})`
        }
      }

      return label
    },

    getTaxAmountAsSting() {
      let msg = "non caculé"
      return this.infoCGTax ? this.infoCGTax + ' €' : msg.toLowerCase()
    },

    willBeExpired() {
      return moment().diff(moment(this.appointmentDate), 'days') < 0
    },

    promoQuery() {
      return gql`
        {
          checkPromoCode (codePromo: "${this.codePromo.input}") {
            isValid
            name
            value
          }
        }`
    },

    cancelDisposalMutation() {
      return gql`
          mutation {
            deleteSaleRdv(saleRdvId: ${this.command.saleRdv[0].id})
            {
              result
            }
          }`
    },

    soldMutation() {
      return gql`
          mutation {
            vehicleSold(orderId: ${this.command.id}) {
              result
            }
          }
        `;
    },

    modifyOrderMutation() {
      let warranty = this.options.warrantyOption ? this.options.warrantyOption : this.options.warranty
      let zip = this.orderInfo.registrationCertificatePrice === 0 ? null : `"${this.zipCode}"`
      return gql`
        mutation {
          modifyOrder(
            orderId:"${this.commandId}",
            commercial: ${this.commercial.id},
            warranty: ${warranty},
            paymentMode: ${this.options.payment},
            cessionMode: ${this.options.disposalType},
            status: ${this.command.status.id},
            promoCode: "${this.codePromo.details ? this.codePromo.details.name : ''}",
            deliveryPrice: ${this.orderInfo.deliveryPrice},
            deliveryAddress: "${addressToString(this.delivery.address)}",
            carImmatriculationDocumentPrice: ${this.orderInfo.registrationCertificatePrice},
            carImmatriculationPrice: ${this.orderInfo.registrationPrice},
            department: "${this.department}",
            region: "${this.area}",
            zip: ${zip}
          ) {
            id,
            status,
            result
            }
         }`
    },

    purchasePaymentMutation() {
      let urls = this.getPurchasePaymentUrls()
      let warranty = this.options.warrantyOption ? this.options.warrantyOption : this.options.warranty

      return gql`
        mutation {
          purchasePaymentForOrder(
            orderId: ${this.command.id},
            warrantyId: ${warranty},
            customerId: ${this.buyer.id},
            deliveryMode: "${this.options.disposalType}",
            paymentMode: "${this.options.payment}",
            priceDelivery: ${this.getDisposalPrice},
            priceToPaid: ${this.getChangeOptionsAmount - this.getOverAmount},
            url: {
              confirmation: "${urls.confirmation}",
              error: "${urls.error}",
              cancel: "${urls.cancel}"
            }
          ) {
            result
            }
         }`
    },

    purchaseDelayedPaymentForOrderMutation() {
      let urls = this.getPurchasePaymentUrls()

      return gql`
          mutation {
            purchaseDelayedPaymentForOrder(
              orderId: ${this.command.id},
              amount: ${this.credit.amount},
              url: {
                confirmation: "${urls.confirmation}",
                error: "${urls.error}",
                cancel: "${urls.cancel}"
              }
            ) {
              result
              }
           }`
    },

    purchasePaymentSuccessMutation() {
      return gql`
        mutation {
          purchasePaymentSuccessForOrder(
            orderId: ${this.command.id},
            responseToken: "${this.purchasePaymentResponseToken}"
          ) {
            result
            }
         }`
    },

    modifyCustomerSatisfactionMutation() {
      return gql`
          mutation {
            customerSatisfaction(
              orderId:"${this.commandId}",
              satisfaction: "${this.satisfaction.satisfaction}",
              comment: "${this.satisfaction.comment}",
            ) {
              result
              }
           }`
    },

    saveButtonLabel() {
      return 'Enregistrer les modifications'
    },

    hasDatePassed() {
      if (this.appointmentDate === null || this.appointmentDate === "") {
        return false
      }

      let now = moment()
      let date = moment(this.appointmentDate, 'DD-MM-YYYY HH:mm:ss')

      return (date.diff(now)) < 0
    },

    getCreditUrl() {
      return process.env.VUE_APP_BACKOFFICE_DOMAIN + `/achat/credit/${this.command.ad.id}/simulateur`
    }
  },

  watch: {
    'options.payment': function () {
      if (this.options.payment === paymentMode.BANK_CHECK_PAYMENT_MODE) {
        this.options.disposalType = appointmentMode.DISPOSAL
      }
    },
    'options.disposalType': function () {
      if (this.options.disposalType === appointmentMode.DELIVERY) {
        //this.options.payment = paymentMode.TRANSFER_PAYMENT_MODE
      }
    },
  },

  async created() {
    await this.getWarrantyOptions()
    if (this.command.options !== null) {
      this.command.options.map((x) => {
        if (x.type === "warranty") {
          if (this.isFinalized()) {
            this.options.warranty = x.id
            this.optionsOldWarranty.id= x.id
            this.optionsOldWarranty.name= x.name
            if (x.isWarrantyOption) {
              this.warrantyOptionDisabled = true
              this.options.warranty = this.getWarrantyChoose(x.id)[0]?.id
              this.options.warrantyOption = x.id
            }
          }else {
            if (this.availableWarranty()){
              this.options.warranty = x.id
              this.optionsOldWarranty.id= x.id
              this.optionsOldWarranty.name= x.name
            }else {
              if(x.isWarrantyOption) {
                this.warrantyOptionDisabled = true
                this.options.warranty = this.getWarrantyChoose(x.id)[0]?.id
                this.options.warrantyOption = x.id
              }
              else this.options.warranty = x.id
            }
          }
        }
        if (x.type === "immatriculation") this.options.registration = x.id
        if (x.type === "immatriculationDocument") this.options.carRegistrationDocument = x.id
      })
    }
    if (this.command.department) {
      this.department = this.command.department
    }

    if (this.command.region) {
      this.area = this.command.region
    }

    this.options.disposalType = this.command.delivery ? appointmentMode.DELIVERY : appointmentMode.DISPOSAL
    this.options.payment = this.command.paymentMode

    if (this.options.disposalType === appointmentMode.DELIVERY) {
      this.delivery.isDelivery = true;
    }

    if (this.command.promoCode) {
      this.codePromo.details = this.command.promoCode
    }
    store.order.id = this.$route.params.id
    this.zipCode = this.command.zip
    this.getOrderInformationQuery()
    this.creditProject()
  },

  async mounted() {
    this.commercial = this.command.commercial
    this.displayReplanButton = !this.command.delivery
    this.options.payment = this.command.paymentMode

    if (this.command.paymentMode === paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE || this.command.paymentMode === paymentMode.CREDIT_PAYMENT_MODE_COFIDIS || this.command.paymentMode === paymentMode.CREDIT_PAYMENT_MODE_YOUNITED)
      this.credit_payment_mode.isCredit = true;

    this.$bus.$on('warranty-confirm-success', this.onWarrantyConfirm)
    this.$bus.$on('payment-confirm-success', this.onPaymentConfirm)
    this.$bus.$on('grise-confirm-success', this.onCarRegistrationDocumentConfirm)
    this.$bus.$on('immat-confirm-success', this.onRegistrationConfirm)
    this.$bus.$on('disposal-confirm-success', this.onDisposalConfirm)
    this.$bus.$on('delete-confirm-success', this.onDelete)
    this.$bus.$on('reason-confirm-success', this.onReasonConfirm)
    this.$bus.$on('nonSold-confirm-success', this.onNonSold)
    this.$bus.$on('replan-confirm-success', this.onReplan)
    this.$bus.$on('sold-confirm-success', this.onSold)
    this.$bus.$on('credit-wallet-success', this.onCreditWalletModalConfirm)

    this.customerSatisfactionQuery()

    if (this.command.delivery) {
      await this.getDeliveryInfosQuery()
    } else if (this.command.saleRdv) {
      this.appointmentDate = this.command.saleRdv[0].date
    }

    this.getWarrantyContractInfoQuery()

    this.lemonwayBankFootprintError = false
    this.lemonwayBankFootprintErrorMessage = ""

    if (window.location.href.indexOf("success") > -1) {
      if (store.data.pendingOrder.depositMode === "delayed") {
        const url = window.location.href.split('?')
        const params = url[1].split('&')

        const result = params.find((e) => {
          return (e.includes('response_wkToken'))
        });

        if (undefined !== result) {
          this.purchasePaymentResponseToken = result.split('=')[1]

          await this.purchasePaymentSuccess()

        } else {
          this.showBanner('danger', `Une erreur est survenue, veuillez contacter l'IT`)
        }
      }
    } else if (window.location.href.indexOf("error") > -1) {
      this.lemonwayBankFootprintErrorMessage = "L'empreinte n'a pas pu être effectuée. Veuillez contacter l'IT."
      this.lemonwayBankFootprintError = true
      this.showBanner('danger', `L'empreinte n'a pas pu être effectuée. Une erreur est survenue, veuillez contacter l'IT`)
    } else if (window.location.href.indexOf("cancel") > -1) {
      this.showBanner('danger', `L'opération a été annulée`)
    }
    $(document).trigger('vue-loaded')
  },

  destroyed() {
    this.$bus.$off('warranty-confirm-success', this.onWarrantyConfirm)
    this.$bus.$off('payment-confirm-success', this.onPaymentConfirm)
    this.$bus.$on('immatriculation-confirm-success', this.onCarRegistrationDocumentConfirm)
    this.$bus.$on('registration-confirm-success', this.onRegistrationConfirm)
    this.$bus.$off('disposal-confirm-success', this.onDisposalConfirm)
    this.$bus.$off('delete-confirm-success', this.onDelete)
    this.$bus.$off('nonSold-confirm-success', this.onNonSold)
    this.$bus.$off('replan-confirm-success', this.onReplan)
    this.$bus.$off('sold-confirm-success', this.onSold)
    this.$bus.$off('credit-wallet-success', this.onCreditWalletModalConfirm)
  },

  methods: {
    availableWarranty() {
      let date = this.command.creationDate?.split(" ")
      let creationDate = date[0]?.split("-")
      let result = `${creationDate[2]}-${creationDate[1]}-${creationDate[0]}`
      return result <= `2024-02-02`
    },
    filteredAndSorted() {
      // function to compare names
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return this.departmentList.filter(department => {
        return department.area.toLowerCase().includes(this.area?.toLowerCase())
      }).sort(compare)
    },
    async getWarrantyOptions() {
      const warrantyOptions = await this.$apollo.query({
        query: gql`
                    query {
                     warrantyOptions (
                     adId: ${this.command.ad.id}
                     orderId: ${this.commandId}
                     fromBO: ${this.fromBO}
                     ) {
                        id,
                        name,
                        price,
                        isPremiumMapFre,
                        option {
                            reference
                            name
                            price
                        }
                    }
              }`,
        fetchPolicy: 'no-cache'
      })
      this.warrantyOptions = warrantyOptions.data.warrantyOptions
      return warrantyOptions.data.warrantyOptions
    },
    async creditProject() {
      const creditProjectInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getCreditProjectInfo (adId: ${this.command.ad.id}) {
                       email
                       deposit
                       amountBorrowed
                       durationValues
                       amountTotal
                       financingCost
                       filingFees
                       taeg
                       lendingRate
                       monthlyPaymentWithoutInsurance
                       insurances {name rent taea totalCost }
                       monthlyPayment
                    }
              }`,
        fetchPolicy: 'no-cache'
      })
      this.credit_payment_mode.email = creditProjectInfo.data.getCreditProjectInfo.email
      this.credit_payment_mode.deposit = creditProjectInfo.data.getCreditProjectInfo.deposit
      this.credit_payment_mode.amountBorrowed = creditProjectInfo.data.getCreditProjectInfo.amountBorrowed
      this.credit_payment_mode.durationValues = creditProjectInfo.data.getCreditProjectInfo.durationValues
      this.credit_payment_mode.amountTotal = creditProjectInfo.data.getCreditProjectInfo.amountTotal
      this.credit_payment_mode.financingCost = creditProjectInfo.data.getCreditProjectInfo.financingCost
      this.credit_payment_mode.filingFees = creditProjectInfo.data.getCreditProjectInfo.filingFees
      this.credit_payment_mode.taeg = creditProjectInfo.data.getCreditProjectInfo.taeg
      this.credit_payment_mode.lendingRate = creditProjectInfo.data.getCreditProjectInfo.lendingRate
      this.credit_payment_mode.monthlyPaymentWithoutInsurance = creditProjectInfo.data.getCreditProjectInfo.monthlyPaymentWithoutInsurance
      this.credit_payment_mode.monthlyPayment = creditProjectInfo.data.getCreditProjectInfo.monthlyPayment
      this.credit_payment_mode.insurances.name = creditProjectInfo.data.getCreditProjectInfo.insurances.name
      this.credit_payment_mode.insurances.rent = creditProjectInfo.data.getCreditProjectInfo.insurances.rent
      this.credit_payment_mode.insurances.taea = creditProjectInfo.data.getCreditProjectInfo.insurances.taea
      this.credit_payment_mode.insurances.totalCost = creditProjectInfo.data.getCreditProjectInfo.insurances.totalCost

    },
    async getOrderInformationQuery() {
      let isRegistrationDocument = this.options.carRegistrationDocument ? true : false
      let isRegistration = this.options.registration ? true : false
      let zip = isRegistrationDocument ? `"${this.zipCode}"` : null
      let warranty = this.options.warrantyOption ? this.options.warrantyOption : this.options.warranty
      const orderInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getOrderInformation (orderId: ${this.commandId}, warranty: ${warranty}, paymentMode: ${this.command.paymentMode}, isDelivery: "false",
                      isRegistrationDocument: "${isRegistrationDocument}",
                      isRegistration: "${isRegistration}",
                      zip: ${zip},
                      delivery: {
                          address: "${this.delivery.address.address}",
                          zipCode: "${this.delivery.address.zipCode}",
                          city: "${this.delivery.address.city}",
                          coordinate: {
                              start: {
                                  latitude: ${this.delivery.coordinate.start.latitude},
                                  longitude: ${this.delivery.coordinate.start.longitude},
                              },
                              end: {
                                  latitude: ${this.delivery.coordinate.end.latitude},
                                  longitude: ${this.delivery.coordinate.end.longitude},
                              }
                          }
                        }
                        ) {
                        warranty { isPremiumMapFre label price surtaxedWarrantyPrice}
                        deliveryPrice
                        paymentMode
                        feesPrice
                        registrationCertificatePrice
                        carRegistrationDocumentEcoTaxPrice
                        receivedAmount
                        totalAmount
                        remainingAmount
                        saleCommission
                        overAmount
                        buyerPrice
                        sellerPrice
                        changeOptionsAmount
                        totalOperationAmount
                        carRegistrationDocumentPrice
                        carRegistrationPrice
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.orderInfo.warranty.label = orderInfo.data.getOrderInformation.warranty.label
      this.orderInfo.warranty.price = orderInfo.data.getOrderInformation.warranty.price
      this.orderInfo.warranty.surtaxedWarrantyPrice = orderInfo.data.getOrderInformation.warranty.surtaxedWarrantyPrice
      this.orderInfo.warranty.isPremiumMapFre = orderInfo.data.getOrderInformation.warranty.isPremiumMapFre
      this.orderInfo.deliveryPrice = orderInfo.data.getOrderInformation.deliveryPrice
      this.orderInfo.paymentMode = orderInfo.data.getOrderInformation.paymentMode
      this.orderInfo.feesPrice = orderInfo.data.getOrderInformation.feesPrice
      this.orderInfo.registrationCertificatePrice = orderInfo.data.getOrderInformation.carRegistrationDocumentPrice
      this.orderInfo.carRegistrationDocumentEcoTaxPrice = orderInfo.data.getOrderInformation.carRegistrationDocumentEcoTaxPrice
      this.orderInfo.registrationPrice =  orderInfo.data.getOrderInformation.carRegistrationPrice
      this.orderInfo.receivedAmount = orderInfo.data.getOrderInformation.receivedAmount
      this.orderInfo.totalAmount = orderInfo.data.getOrderInformation.totalAmount
      this.orderInfo.remainingAmount = orderInfo.data.getOrderInformation.remainingAmount
      this.orderInfo.saleCommission = orderInfo.data.getOrderInformation.saleCommission
      this.orderInfo.overAmount = orderInfo.data.getOrderInformation.overAmount
      this.orderInfo.buyerPrice = orderInfo.data.getOrderInformation.buyerPrice
      this.orderInfo.sellerPrice = orderInfo.data.getOrderInformation.sellerPrice
      this.orderInfo.changeOptionsAmount = orderInfo.data.getOrderInformation.changeOptionsAmount
      this.orderInfo.totalOperationAmount = orderInfo.data.getOrderInformation.totalOperationAmount
    },

    async getOrderInformationChangedOptionsQuery() {
      let isRegistrationDocument = this.options.carRegistrationDocument ? true : false
      let isRegistration = this.options.registration ? true : false
      let zip = isRegistrationDocument ? `"${this.zipCode}"` : null
      let warranty = this.options.warrantyOption ? this.options.warrantyOption : this.options.warranty
      const orderInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getOrderInformation (orderId: ${this.commandId}, warranty: ${warranty}, paymentMode: ${this.options.payment}, isDelivery: "true",
                      isRegistrationDocument: "${isRegistrationDocument}",
                      isRegistration: "${isRegistration}",
                      zip: ${zip},
                      delivery: {
                          address: "${this.delivery.address.address}",
                          zipCode: "${this.delivery.address.zipCode}",
                          city: "${this.delivery.address.city}",
                          coordinate: {
                              start: {
                                  latitude: ${this.delivery.coordinate.start.latitude},
                                  longitude: ${this.delivery.coordinate.start.longitude},
                              },
                              end: {
                                  latitude: ${this.delivery.coordinate.end.latitude},
                                  longitude: ${this.delivery.coordinate.end.longitude},
                              }
                          }
                        }
                        ) {
                        warranty {label price}
                        deliveryPrice
                        paymentMode
                        feesPrice
                        registrationCertificatePrice
                        carRegistrationDocumentEcoTaxPrice
                        receivedAmount
                        totalAmount
                        remainingAmount
                        saleCommission
                        overAmount
                        buyerPrice
                        sellerPrice
                        changeOptionsAmount
                        totalOperationAmount
                        carRegistrationDocumentPrice
                        carRegistrationPrice
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.orderInfo.warranty.label = orderInfo.data.getOrderInformation.warranty.label
      this.orderInfo.warranty.price = orderInfo.data.getOrderInformation.warranty.price
      this.orderInfo.deliveryPrice = orderInfo.data.getOrderInformation.deliveryPrice
      this.orderInfo.paymentMode = orderInfo.data.getOrderInformation.paymentMode
      this.orderInfo.feesPrice = orderInfo.data.getOrderInformation.feesPrice
      this.orderInfo.registrationCertificatePrice = orderInfo.data.getOrderInformation.carRegistrationDocumentPrice
      this.orderInfo.carRegistrationDocumentEcoTaxPrice = orderInfo.data.getOrderInformation.carRegistrationDocumentEcoTaxPrice
      this.orderInfo.registrationPrice =  orderInfo.data.getOrderInformation.carRegistrationPrice
      this.orderInfo.receivedAmount = orderInfo.data.getOrderInformation.receivedAmount
      this.orderInfo.totalAmount = orderInfo.data.getOrderInformation.totalAmount
      this.orderInfo.remainingAmount = orderInfo.data.getOrderInformation.remainingAmount
      this.orderInfo.saleCommission = orderInfo.data.getOrderInformation.saleCommission
      this.orderInfo.overAmount = orderInfo.data.getOrderInformation.overAmount
      this.orderInfo.buyerPrice = orderInfo.data.getOrderInformation.buyerPrice
      this.orderInfo.sellerPrice = orderInfo.data.getOrderInformation.sellerPrice
      this.orderInfo.changeOptionsAmount = orderInfo.data.getOrderInformation.changeOptionsAmount
      this.orderInfo.totalOperationAmount = orderInfo.data.getOrderInformation.totalOperationAmount
      this.orderInfo.delivery.address = this.delivery.address.address
      this.orderInfo.delivery.zipCode = this.delivery.address.zipCode
      this.orderInfo.delivery.city = this.delivery.address.city
    },

    getPurchasePaymentUrls() {
      return {
        confirmation: process.env.VUE_APP_BACKOFFICE_CDN_PATH + `/#/command/${this.command.id}/success`,
        error: process.env.VUE_APP_BACKOFFICE_CDN_PATH + `/#/command/${this.command.id}/error`,
        cancel: process.env.VUE_APP_BACKOFFICE_CDN_PATH + `/#/command/${this.command.id}/cancel`
      }
    },
    showCreditWalletModal() {
      const command = this.command

      this.showModal({
        childVue: 'credit-wallet',
        size: 'modal-md',
        dataModel: {command},
      })
    },
    setWarrantyContractInfo() {
      this.$apollo.mutate({
        mutation: this.warrantyContractInfoMutation,
      }).then(() => {
        this.getWarrantyContractInfoQuery()
        this.showBanner('success', `Les informations sont enregistrées !`)
      }).catch((error) => {
        this.showBanner('danger', error.networkError.result.errors[0].message)
      })
    },
    addTaxAmount() {
      this.$apollo.mutate({
        mutation: this.taxAmoutMutation,
      }).then(() => {
        this.getInfoCGTax()
        this.showBanner('success', `Coût d'immatriculation enregistré !`)
      }).catch((error) => {
        this.showBanner('danger', error.networkError.result.errors[0].message)
      })
    },

    async onCreditWalletModalConfirm(amount) {
      this.credit.amount = amount

      store.data.pendingOrder = {
        commercial: this.commercial,
        options: this.options,
        codePromo: this.codePromo,
        deliveryAddress: this.delivery.address,
        depositMode: "delayed",
        amount: amount
      }

      localStorage.methods.saveData()

      const result = await this.$apollo.mutate({
        mutation: this.purchaseDelayedPaymentForOrderMutation
      })

      const url = result.data.purchaseDelayedPaymentForOrder.result
      window.open(url, "_self")
    },
    confirm(type) {
      let content = '';
      let title = '';
      if (type === 'warranty') {
        content = 'Souhaitez-vous changer de garantie ?';
        title = 'Êtes-vous sûr ?';
      } else if (type === 'payment') {
        content = 'Souhaitez-vous annuler ce moyen de paiement ?'
        title = 'Êtes-vous sûr ?';
      } else if (type === 'disposal') {
        content = 'Souhaitez-vous annuler ce moyen de cession ?'
        title = 'Êtes-vous sûr ?';
      } else if (type === 'sold') {
        title = "Véhicule vendu";
        content = "Super !";
      } else if (type === 'immat') {
        title = "Souhaitez-vous changer l'option d'immatriculation ?";
        content = "Êtes-vous sûr ?";
      } else if (type === 'grise') {
        title = "Souhaitez-vous changer l'option de carte grise ?";
        content = "Êtes-vous sûr ?";
      }

      this.showModal({
        childVue: 'confirm',
        dataModel: {
          title: title,
          content,
          type
        }
      })
    },

    sold() {
      this.confirm('sold')
    },

    onSold() {
      this.$apollo.mutate({
        mutation: this.soldMutation
      }).then(() => {
        this.showBanner('success', `Succès: le véhicule a bien été vendu !`)
      }, () => {
        this.showBanner('danger', `Le véhicule n'a pas pu être vendu`)
      })
    },

    nonSold() {
      this.showModal({
        childVue: 'NonSold'
      })
    },

    onNonSold() {
      this.showModal({
        childVue: 'Reason'
      })
    },

    replan() {
      this.showModal({
        childVue: 'Replan'
      })
    },

    onReplan() {
      this.showModal({
        childVue: 'ReplanReason',
        dataModel: {
          saleRdvId: this.command.saleRdv[0].id
        }
      })
    },

    deleteOrder() {
      this.showModal({
        childVue: 'CancelReason',
        dataModel: {
          orderId: this.command.id
        }
      })
    },

    onDelete() {
      this.showModal({
        childVue: 'deleteOrder'
      })
    },

    onReasonConfirm() {
      this.$router.push({name: 'commands-list'})
    },

    onWarrantyConfirm() {
      this.warrantyDisabled = false
    },

    onPaymentConfirm() {
      this.paymentDisabled = false
    },

    onRegistrationConfirm() {
      this.registrationDisabled = false
    },

    onCarRegistrationDocumentConfirm() {
      this.carRegistrationDocumentDisabled = false
    },

    onDisposalConfirm() {
      this.disposalTypeDisabled = false

      if (this.command.saleRdv) {
        this.$apollo.mutate({
          mutation: this.cancelDisposalMutation
        }).then(() => {
          this.showBanner('success', `Succès: Le rendez-vous de cession a bien été supprimé`)
          this.command.saleRdv = null
          this.command.status.id = Status.constants.TO_PLANIFY
        })
      }
    },

    applyPromo() {
      this.$apollo.query({
        query: this.promoQuery
      }).then((response) => {
        if (response.data.checkPromoCode.isValid) {
          this.codePromo.details = response.data.checkPromoCode
          this.showBanner('success', `Succès: code promo ${this.codePromo.details.name} appliqué`)
        } else {
          this.codePromo.details = null
          this.showBanner('danger', `Le code promo indiqué n'est pas valide`)
        }
      })
    },

    onDeleteOrderConfirm() {
      this.$apollo.mutate({
        mutation: this.deleteCommandQuery
      }).then(() => {
        this.showBanner('success', `Succès: la commande #${this.commandId} a bien été annulée`)
        this.$router.push('/')
      }, () => {
        this.showBanner('danger', `La commande #${this.commandId} n'a pas pu être annulée`)
      })
    },

    async modifyOrder() {
      if (this.commercial.id.length == 0) {
        this.showBanner('danger', `Veuillez sélectionner un commercial`)
        return;
      }

      let mutationOrder = this.modifyOrderMutation

      await this.$apollo.mutate({
        mutation: mutationOrder
      }).then(() => {
        this.showBanner('success', `Succès: la commande #${this.commandId} a bien été modifiée`)
      }, () => {
        this.showBanner('danger', `La commande #${this.commandId} n'a pas pu être modifiée`)
      })
      // Client Review Light
      await this.$apollo.mutate({
        mutation: this.modifyCustomerSatisfactionMutation
      }).then(() => {
        // this.showBanner('success', `Succès: l'avis client a bien été modifié`)
      }, () => {
        // this.showBanner('danger', `L'avis client n'a pas pu être modifié`)
      })
    },

    async purchasePayment() {
      store.data.pendingOrder = {
        commercial: this.commercial,
        options: this.options,
        codePromo: this.codePromo,
        deliveryAddress: this.delivery.address,
        depositMode: "delayed",
        orderInfo: this.orderInfo,
        area: this.area,
        department: this.department,
        zipCode: this.zipCode
      }

      localStorage.methods.saveData()

      const result = await this.$apollo.mutate({
        mutation: this.purchasePaymentMutation
      })

      const url = result.data.purchasePaymentForOrder.result

      window.open(url, "_self")
    },

    async purchasePaymentSuccess() {
      this.purchasePaymentSuccessisLoading = true

      const result = await this.$apollo.mutate({
        mutation: this.purchasePaymentSuccessMutation
      })

      const success = result.data.purchasePaymentSuccessForOrder.result

      if (success === "success payment") {
        if (this.credit.amount) {
          this.showBanner('success', "L'empreinte de " + this.credit.amount + '€ a bien été éffectué.')
        }
        this.commercial = store.data.pendingOrder.commercial
        this.options = store.data.pendingOrder.options
        this.codePromo = store.data.pendingOrder.codePromo
        this.delivery.address = store.data.pendingOrder.deliveryAddress
        this.$refs.gmapAddress.$el.value = addressToString(this.delivery.address)
        this.orderInfo = store.data.pendingOrder.orderInfo
        this.area = store.data.pendingOrder.area
        this.department = store.data.pendingOrder.department
        this.zipCode = store.data.pendingOrder.zipCode

        if (store.data.pendingOrder.amount) {
          this.credit.amount = store.data.pendingOrder.amount
        }
        await this.modifyOrder()
        delete store.data.pendingOrder
        localStorage.methods.saveData()
      } else {
        this.showBanner('danger', `Le paiement n'a pas pu être effectué`)
      }

      this.purchasePaymentSuccessisLoading = false
    },

    toggleCodePromoInput() {
      this.codePromo.showInput = !this.codePromo.showInput
    },

    async getWarrantyContractInfoQuery() {
      const warrantyContractInfo = await this.$apollo.query({
        query: gql`
                  query {
                   getWarrantyContractInfo(orderId: "${this.commandId}") {
                     optevenContractId
                     youSignContractId
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      this.warrantyContract.opteven.id = warrantyContractInfo.data.getWarrantyContractInfo.optevenContractId
      this.warrantyContract.yousign.id = warrantyContractInfo.data.getWarrantyContractInfo.youSignContractId
    },
    async customerSatisfactionQuery() {
      this.customerSatisfactionQueryisLoading = true

      const customerSatisfaction = await this.$apollo.query({
        query: gql`
                  query {
                   customerSatisfaction(orderId: "${this.commandId}") {
                     satisfaction
                     comment
                   }
                  }`,
        fetchPolicy: 'no-cache'
      })

      this.satisfaction.satisfaction = customerSatisfaction.data.customerSatisfaction.satisfaction
      this.satisfaction.comment = customerSatisfaction.data.customerSatisfaction.comment

      this.customerSatisfactionQueryisLoading = false
    },
    async getDeliveryInfosQuery() {
      this.getDeliveryInfosQueryisLoading = true

      const getDeliveryInfos = await this.$apollo.query({
        query: gql`
              query {
               deliveryInfos(orderId: "${this.commandId}") {
                  price
                  date
                  address
               }
              }`,
        fetchPolicy: 'no-cache'
      })

      let defaultPlace = getDeliveryInfos.data.deliveryInfos.address
      this.$refs.gmapAddress.$el.value = defaultPlace

      const regexZipCode = /[0-9]{5}/g;

      let zipCodeIndex = defaultPlace.search(regexZipCode)

      this.appointmentDate = getDeliveryInfos.data.deliveryInfos.date
      this.delivery.address.address = defaultPlace.slice(0, zipCodeIndex - 1)
      this.delivery.address.zipCode = defaultPlace.slice(zipCodeIndex, zipCodeIndex + 5)
      this.delivery.address.city = defaultPlace.slice(zipCodeIndex + 6)
      this.getDeliveryInfosQueryisLoading = false
    },
    async onRegistrationDocumentChangeZipCodeOptions() {
      if (this.options.carRegistrationDocument) {
        if (this.completeAddressNeeded) {
          this.showBanner('danger', `Veuillez saisir un code postal complet pour continuer`)
        } else {
          if (this.zipCode.length === 5) {
            await this.getOrderInformationChangedOptionsQuery()
          }
        }
      }
    },
    async onChangeOptions(option) {
      this.options.warrantyOption = null
      if (this.options.disposalType === appointmentMode.DELIVERY) {
        this.delivery.isDelivery = true;
      }
      if (this.options.disposalType && this.options.warranty || this.options.payment || this.options.carRegistrationDocument || this.options.registration) {
        if (this.completeAddressNeeded) {
          this.showBanner('danger', `Veuillez saisir une adresse complète pour continuer`)
        } else {
          await this.getOrderInformationChangedOptionsQuery()

          if (option == "warranty") {
            this.AmountOption.warranty = this.orderInfo.warranty.price
          }
          if (option == "appointment") {
            this.AmountOption.appointment = this.orderInfo.deliveryPrice
          }
          if (option == "immat") {
            if (this.options.registration === null) {
              this.department = null
              this.area = null
            }
            this.AmountOption.registration = this.orderInfo.registrationPrice
          }
          if (option == "grise") {
            this.AmountOption.carRegistrationDocument = this.orderInfo.registrationCertificatePrice
          }
        }
      }
      if (this.options.warranty) this.warrantyOptionDisabled = true
    },
    isFinalized(){
      return this.command.status.id === '7'
    },
    getWarrantyChoose(warrntyId) {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      return this.warrantyOptions?.filter(option => {
        return option?.option?.reference.includes(warrntyId)
      }).sort(compare)
    },
    getWarrantyListOptions() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      return this.warrantyOptions?.filter(option => {
        if (this.options.warranty !== '1') return option.id.includes(this.options.warranty)
      }).sort(compare)
    },
    warrantyOptionReference() {
      return this.getWarrantyListOptions()[0]?.option
    },
    onPlaceChanged(place) {
      this.delivery.address = formatAddress(place)
      this.delivery.coordinate.end.latitude = place.geometry.location.lat()
      this.delivery.coordinate.end.longitude = place.geometry.location.lng()

      if (this.isAddressIncomplete(this.delivery.address)) {
        this.showBanner('danger', 'Veuillez saisir une adresse complète pour continuer')
      } else {
        this.isNewDeliveryAddress = true
        this.onChangeOptions('appointment')
      }
    },

    resetAddress() {
      this.delivery.address.address = this.delivery.address.zipCode = this.delivery.address.city = '';
    }

  },

  apollo: {
    accountManager: {
      query: CommercialList
    }
  }
}
</script>
